import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['item']

  search(e) {
    const query = e.target.value.toLowerCase();

    this.itemTargets.forEach(item => {
      const value = item.dataset.value.toLowerCase();
      if (value.includes(query)) {
        item.classList.remove("hidden");
      } else {
        item.classList.add("hidden");
      }
    });
  }
}
